import _ from 'lodash'
import Backbone from 'backbone'
import template from './zapier-connection-step1.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import Tooltip from 'scoreboard/components/tooltip'
import i18n from 'scoreboard/components/i18n'
import formHelper from '../../components/form-helper'
import FormView from '../../components/form-view'
import CopyReadOnly from 'scoreboard/components/copy-read-only'

var ZapierConnectionStep1 = Backbone.View.extend({

	className: 'zapier-connection-step1',

	tagName: 'form',

	template,

	/**
	 * @typedef IntegrationToken see IntegrationToken.kt
	 * @property {String} apiToken
	 */

	/**
	 * @param {Object} options
	 *
	 * @param {Connection} options.model
	 *
	 * @param {String} options.title From wizard initialization
	 *
	 * @param {Wizard} options.wizard
	 *
	 * @param {IntegrationToken} [options.xhrResponse] will only be present when
	 * a new connection is being made.  When editing an existing connection
	 * the model will contain the token.
	 */
	initialize(options = {}) {
		this.options = options
		this.xhrToken = _.get(options.xhrResponse, 'apiToken')
		// New connections will have this in the XHR,
		// but editing existing connections should read from the model
		if (this.xhrToken) {
			this.model.set('orbReferenceId', this.xhrToken)
			this.model.set('orbReferenceId', this.xhrToken)
		}
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(_.extend({
			title: this.options.title,
			hasClipboard: navigator.clipboard // requires https; https://stackoverflow.com/a/51823007/5656782
		}, this.model.attributes)))
		formHelper.writeToDom(this.model, this.el)
		this.options.wizard.render({
			formView: this.formView,
			customPrimaryButtonKey: 'admin.importConnections.zapier.instructionsComplete'
		})

		// Adding these descriptions/instructions with JS because they contain links.
		// The rest of the descriptions/instructions are added in the template file.
		let paragraphOneKey = 'admin.importConnections.zapier.instruction.title1'
		let paragraphOneLink =
			`<a href="https://support.spiderstrategies.com/hc/en-us/articles/7288734211988-Importing-Data-with-Zapier" target="_blank" class="text-link">
			${i18n.get(paragraphOneKey + '.linkText')}
			</a>`
		this.$('.paragraph-one').html(i18n.get(paragraphOneKey, paragraphOneLink))
		let instructionTwoKey = 'admin.importConnections.zapier.instruction2'
		let instructionTwoLink =
			`<a href="https://zapier.com/app/connections" target="_blank" class="text-link">
			${i18n.get(instructionTwoKey + '.linkText')}
			</a>`
		this.$('.instruction-two').html(i18n.get(instructionTwoKey, instructionTwoLink))

		this.copyReadOnly = new CopyReadOnly({
			el: this.$('.read-only-input'),
			text: this.model.get('orbReferenceId')
		})

		this.formView.start()
		return this
	},

	submit: function() {
		// No state on this view, we're just showing the readonly token to the user
		this.options.wizard.next()
	},

	removeTooltip: function() {
		this.tooltip && this.tooltip.remove()
	},

	remove: function() {
		_.invokeMap([this.tooltip, this.covertButtonTooltips,
		this.copyReadOnly], 'remove')
	},
})

export default ZapierConnectionStep1

ZapierConnectionStep1.__filename__ = 'admin/connections/zapier-connection-step1.js'
